import React, { useState } from 'react';
import { QuizStartScreen } from './QuizStartScreen';
import { QuizBoard } from './QuizBoard';
import { QuizResultsScreen } from './QuizResultsScreen';
import { Specialty } from '../types';
export interface RoundData {
  id: number;
  title: string;
  question: string;
  options: string[];
  answers: Record<Specialty, string>;
  insights: Record<Specialty, string>;
}
export const GAME_DATA: RoundData[] = [{
  id: 1,
  title: 'Treatment Approach',
  question: 'What is their typical approach to CKD?',
  options: ['Late / Cautious', 'Early / Proactive', 'Metabolic-Focused', 'Conservative'],
  answers: {
    Nephrologist: 'Late / Cautious',
    Cardiologist: 'Early / Proactive',
    Endocrinologist: 'Metabolic-Focused',
    PCP: 'Conservative'
  },
  insights: {
    Nephrologist: 'Adopt a cautious, late-stage approach due to late referrals and safety concerns.',
    Cardiologist: 'Highly proactive and outcome-driven, embracing early multi-modal treatment.',
    Endocrinologist: 'Proactive through a metabolic lens but defer non-glycaemic treatment escalation.',
    PCP: 'Conservative and guideline-dependent with low confidence in treatment escalation.'
  }
}, {
  id: 2,
  title: 'Primary Driver',
  question: 'What primarily drives their treatment decisions?',
  options: ['Safety Data', 'Outcome Evidence', 'Guidelines & Data', 'Peer Behavior'],
  answers: {
    Nephrologist: 'Safety Data',
    Cardiologist: 'Outcome Evidence',
    Endocrinologist: 'Guidelines & Data',
    PCP: 'Peer Behavior'
  },
  insights: {
    Nephrologist: 'Safety data is the primary motivator for treatment decisions.',
    Cardiologist: 'Outcome evidence and CV benefit data drive treatment decisions.',
    Endocrinologist: 'Guidelines and comprehensive data analysis guide treatment choices.',
    PCP: 'Peer behavior and social proof strongly influence treatment adoption.'
  }
}, {
  id: 3,
  title: 'Key Barrier',
  question: 'What is their biggest barrier to optimal care?',
  options: ['Late Referrals', 'Workload', 'Lack of Guidance', 'Low Confidence'],
  answers: {
    Nephrologist: 'Late Referrals',
    Cardiologist: 'Workload',
    Endocrinologist: 'Lack of Guidance',
    PCP: 'Low Confidence'
  },
  insights: {
    Nephrologist: 'Late referrals limit opportunities for early intervention.',
    Cardiologist: 'High patient volume and workload constraints limit treatment optimization.',
    Endocrinologist: 'Insufficient guidance on non-glycaemic treatment escalation.',
    PCP: 'Low confidence in complex treatment escalation decisions.'
  }
}];
export function QuizGame() {
  const [gameState, setGameState] = useState<'start' | 'playing' | 'results'>('start');
  const [currentRoundIndex, setCurrentRoundIndex] = useState(0);
  const [score, setScore] = useState(0);
  const [roundScores, setRoundScores] = useState<number[]>([0, 0, 0]);
  const handleStart = () => {
    setGameState('playing');
    setCurrentRoundIndex(0);
    setScore(0);
    setRoundScores([0, 0, 0]);
  };
  const handleRoundComplete = (roundScore: number) => {
    const newRoundScores = [...roundScores];
    newRoundScores[currentRoundIndex] = roundScore;
    setRoundScores(newRoundScores);
    setScore(prev => prev + roundScore);
    if (currentRoundIndex < GAME_DATA.length - 1) {
      setCurrentRoundIndex(prev => prev + 1);
    } else {
      setGameState('results');
    }
  };
  const handlePlayAgain = () => {
    setGameState('start');
  };
  if (gameState === 'start') {
    return <QuizStartScreen onStart={handleStart} data-id="element-212" />;
  }
  if (gameState === 'results') {
    return <QuizResultsScreen score={score} totalQuestions={GAME_DATA.length * 4} roundScores={roundScores} onPlayAgain={handlePlayAgain} data-id="element-213" />;
  }
  return <QuizBoard roundData={GAME_DATA[currentRoundIndex]} currentRoundNum={currentRoundIndex + 1} totalRounds={GAME_DATA.length} onRoundComplete={handleRoundComplete} data-id="element-214" />;
}